import { useUiStore } from '@/stores/ui';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('overlay', {
    mounted(el, binding) {
      if (binding.modifiers.autofocus) {
        // This changes the keyboard focus to the container when it is mounted
        el.tabIndex = '-1';
        el.focus();
      }

      el.addEventListener('focusout', (e: FocusEvent) => {
        // Close the component if all of those cases are true
        // 1. The new focused element is outside of the component with the v-overlay directive
        // 2. The new focused element exists. It does not exist when not focused on anything (such as clicking with mouse on a non-focusable with mouse element), or focused on something outside of the page (console, new tab etc.)
        // 3. The new focused element is focusable through user input. Elements with tabIndex -1 are only focusable through script, and it can happen when opening a v-overlay component through a v-overlay component (modals, flyouts within flyouts etc.)
        if (
          !el.contains(e.relatedTarget) &&
          e.relatedTarget !== null &&
          (e.relatedTarget as HTMLElement).tabIndex !== -1
        ) {
          if (binding.value) {
            binding.value.call();
          } else {
            const uiStore = useUiStore();

            const { clearOverlayComponents } = uiStore;
            clearOverlayComponents();
          }
        }
      });
    },
  });
});
